import { render, staticRenderFns } from "./copyItem.vue?vue&type=template&id=50d7100a&scoped=true&"
import script from "./copyItem.vue?vue&type=script&lang=js&"
export * from "./copyItem.vue?vue&type=script&lang=js&"
import style0 from "./copyItem.vue?vue&type=style&index=0&id=50d7100a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../mercari_web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d7100a",
  null
  
)

export default component.exports